// Notificaciones del navegador (las del sistema operativo). Solo llegan
// mientras la app está abierta en alguna pestaña, aunque no esté a la vista.
// La preferencia de activarlas es de este equipo (localStorage).

const CLAVE_PREFERENCIA = "agenda:notificaciones";
const ICONO = "/Img/logoElecciones.png";

export const notificacionesSoportadas = () => typeof window !== "undefined" && "Notification" in window;

// "granted" | "denied" | "default" | "unsupported"
export const permisoNotificaciones = () => (notificacionesSoportadas() ? Notification.permission : "unsupported");

const leerPreferencia = () => {
  try {
    return localStorage.getItem(CLAVE_PREFERENCIA) !== "off";
  } catch {
    return true;
  }
};

export const guardarPreferenciaNotificaciones = (activas) => {
  try {
    localStorage.setItem(CLAVE_PREFERENCIA, activas ? "on" : "off");
  } catch {
    // sin almacenamiento: queda según el permiso del navegador
  }
};

export const notificacionesActivas = () => permisoNotificaciones() === "granted" && leerPreferencia();

// pide el permiso al navegador; devuelve true si quedó concedido
export const solicitarPermisoNotificaciones = async () => {
  if (!notificacionesSoportadas()) return false;
  const permiso = await Notification.requestPermission();
  guardarPreferenciaNotificaciones(permiso === "granted");
  return permiso === "granted";
};

// En Android, Chrome solo permite notificar desde el service worker; en
// escritorio basta con new Notification. tag evita duplicados del mismo aviso.
export const mostrarNotificacion = async (titulo, cuerpo, tag) => {
  if (!notificacionesActivas()) return;
  const opciones = { body: cuerpo, tag, icon: ICONO, badge: ICONO };
  try {
    const registro = await navigator.serviceWorker?.getRegistration?.();
    if (registro) {
      await registro.showNotification(titulo, opciones);
      return;
    }
    const notificacion = new Notification(titulo, opciones);
    notificacion.onclick = () => {
      window.focus();
      window.location.href = "/agenda";
    };
  } catch (error) {
    console.error("No se pudo mostrar la notificación:", error);
  }
};
